/*
 * Cart "Complete the set" cross-sell — options popup.
 *
 * Single-option pieces add instantly via their form's + button. Multi-option
 * pieces (size / colour) show a "+" that opens a small popup with option
 * dropdowns; picking options updates the hidden variant id, and the popup's Add
 * button submits the form (native /cart/add — product-form.js isn't loaded on the
 * cart page). Everything is event-delegated on document so it keeps working after
 * the cart section re-renders (add / remove / qty change).
 */
(function () {
  'use strict';

  function panel(picker) {
    return picker.querySelector('[data-cc-popup]');
  }

  // Match the chosen option values to a variant and update the hidden id + Add state.
  function sync(picker) {
    var src = picker.querySelector('[data-cc-variants]');
    if (!src) return;
    var variants;
    try { variants = JSON.parse(src.textContent); } catch (e) { return; }
    var selects = picker.querySelectorAll('[data-cc-opt]');
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
    var v = variants.find(function (x) {
      return x.opts.length === chosen.length && x.opts.every(function (o, i) { return o === chosen[i]; });
    });
    var idInput = picker.querySelector('[data-cc-id]');
    var addBtn = picker.querySelector('[data-cc-add]');
    if (v) {
      if (idInput) idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
    } else if (addBtn) {
      addBtn.disabled = true;
    }
  }

  function setOpen(picker, open) {
    var p = panel(picker);
    if (p) p.hidden = !open;
    var t = picker.querySelector('[data-cc-toggle]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) sync(picker);
  }

  function closeAll(except) {
    document.querySelectorAll('[data-cc-picker]').forEach(function (pk) {
      if (pk !== except) setOpen(pk, false);
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-cc-toggle]');
    if (toggle) {
      e.preventDefault();
      var pk = toggle.closest('[data-cc-picker]');
      var isOpen = panel(pk) && !panel(pk).hidden;
      closeAll(pk);
      setOpen(pk, !isOpen);
      return;
    }
    var close = e.target.closest && e.target.closest('[data-cc-close]');
    if (close) {
      e.preventDefault();
      setOpen(close.closest('[data-cc-picker]'), false);
      return;
    }
    // click anywhere outside a picker closes open popups
    if (!(e.target.closest && e.target.closest('[data-cc-picker]'))) closeAll(null);
  });

  document.addEventListener('change', function (e) {
    var opt = e.target.closest && e.target.closest('[data-cc-opt]');
    if (opt) sync(opt.closest('[data-cc-picker]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
